import { Tip } from '~/components/ui/tip';

interface Props {
  className?: string;
  /** Compact variant: smaller logo + text, suitable for sidebars/footers. */
  compact?: boolean;
  /** Environment / build label (e.g. "dev"). Never printed: it rides the hover
   *  and focus hint, so the footer stays one line (FRONT-3143). */
  detail?: string;
}

export function PoweredByBlockbrain({ className = '', compact = false, detail }: Props) {
  const size = compact ? 14 : 18;

  return (
    <Tip label={detail ? `Powered by Blockbrain · ${detail}` : 'Powered by Blockbrain'}>
      <a
        href="https://theblockbrain.ai"
        target="_blank"
        rel="noreferrer"
        className={`flex items-center justify-center gap-1.5 whitespace-nowrap text-muted-foreground/70 hover:text-foreground transition-colors ${className}`}
      >
        <span className={compact ? 'text-[length:var(--text-2xs)]' : 'text-xs'}>Powered by</span>
        <img
          src="/blockbrain-logo-dark.png"
          alt="Blockbrain"
          width={size}
          height={size}
          className="dark:invert"
        />
        <span className={compact ? 'text-[length:var(--text-2xs)] font-medium' : 'text-xs font-medium'}>Blockbrain</span>
      </a>
    </Tip>
  );
}
